import nfetch from "@/utils/events/nfetch";

import RecompensaModel from "../models/programafidelidade/recompensaModel";

import { IService } from "./base/iService";

export default class RecompensaService extends IService<RecompensaModel> {
    constructor() {
        super("Recompensa");
    }

    public resgatarRecompensaByCampanha(
        clienteId: number,
        campanhaId: number,
        recompensaId: number,
    ): Promise<Response> {
        return nfetch(
            `/${this.controllerName}/ResgatarRecompensaByCampanha?clienteId=${clienteId}&campanhaId=${campanhaId}&recompensaId=${recompensaId}`,
            {
                method: "POST",
                credentials: "same-origin",
                headers: {
                    "Content-Type": "application/json",
                },
            },
        );
    }
}
